// import userCash from '@/pages/user/userCash'
import userCashTab from "@/pages/user/cashTab.vue";
// import userSetBinding from '@/pages/user/userBinding'
import userBindingTab from "@/pages/user/bindingTab";
import userCashList from "@/pages/user/trans-detail-tab";
import queryPayShopDepositLog from "@/pages/user/pay-shop-deposit-log";
import layout from "@/components/layout/layout";
const userRouter = {
  path: "/user",
  component: layout,
  meta: { roles: ["jzb"], title: "账户设置", icon: "icon-setting-user" },
  children: [
    {
      path: "/user/binding",
      component: userBindingTab,
      name: "userBinding",
      meta: { roles: ["jzb"], title: "绑定" }
    },
    {
      path: "/user/cash",
      component: userCashTab,
      name: "userCash",
      meta: { roles: ["jzb"], title: "提现" }
    },
    {
      path: "/user/cashList",
      component: userCashList,
      name: "userCashList",
      meta: { roles: ["jzb"], title: "交易明细" }
    },
    {
      path: "/user/queryPayShopDepositLog",
      component: queryPayShopDepositLog,
      name: "queryPayShopDepositLog",
      hidden: true,
      meta: { roles: ["jzb"], title: "担保明细" }
    }
  ]
};
export default userRouter;



// WEBPACK FOOTER //
// ./src/router/modules/userSet.js